module.exports = __webpack_public_path__ + "img/BB 01.e0921249.png";